import { Button, Checkbox, Row } from "antd";
import { Controller, useFormContext } from "react-hook-form";
import { DeleteOutlined } from "@ant-design/icons";

const CheckboxListField = ({ label, top = false, htmlfor, values, required }) => {
  const { register, watch, setValue, control } = useFormContext();

  if (!register) {
    throw new Error("No form content and no register passed");
  }

  const htmlFor = htmlfor ? htmlfor : label;
  const value = watch(htmlFor)

  const checked = !!value && value.length > 0
  const handleChange = () => {
    if (checked) {
      setValue(htmlFor, [], {shouldDirty: true})
    }
  }

  return (
    <div
      className={`sm:grid sm:grid-cols-2 sm:gap-4 sm:items-start ${top ? "" : "sm:border-t"
        } sm:border-gray-200 py-5`}
    >
      <label
        htmlFor={label}
        className="flex items-center text-sm font-medium text-gray-700"
      >
        <Button type="link" icon={<DeleteOutlined />} onClick={handleChange} danger disabled={!checked} />
        {label}
      </label>
      <div className="mt-1 sm:mt-0">
        <Controller
          name={htmlFor}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Checkbox.Group className="flex flex-col" value={value} onChange={onChange}>
                {values.map(({_id, name}) => (
                  <Row key={_id}>
                    <Checkbox value={_id}>{name}</Checkbox>
                  </Row>
                ))}
            </Checkbox.Group>
          )}
          />
      </div>
    </div>
  );
};
export default CheckboxListField;
